// extracted by mini-css-extract-plugin
export default {"text":"Comecar_text__3ko3B","divider":"Comecar_divider__bnmqP","title":"Comecar_title__Qgxh0","description":"Comecar_description__rsSA2"};